import { Skeleton } from "@mui/material";
import Box from "@mui/material/Box";

export const FakePaymentInfos = () => {
  return (
    <Box
      className="btn-group"
      role="group"
      aria-label="Basic checkbox toggle Skeleton group"
    >
      <Skeleton className={"btn"} style={{ marginRight: 10 }} height={150} />
      <Skeleton className={"btn"} style={{ marginRight: 10 }} height={150} />
      <Skeleton className={"btn"} style={{ marginRight: 10 }} height={150} />
      <Skeleton className={"btn"} height={150} />
    </Box>
  );
};
